import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { catchError, finalize, tap } from "rxjs/operators";
import { of } from "rxjs/observable/of";
import { environment } from '../../../../../environments/environment';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusOtherKpFilterService } from '../../services/bus-other-kp-filter.service';
import { OtherKpFilter } from '../../models/other-kp-filter';
import { OtherKpDetailService } from '../../services/other-kp-detail.service';
import { OtherKpModel } from '../../models/other-kp-model';
import { OtherKpExportModel } from '../../models/other-kp-export-model';
import { LoggingService } from '../../../../services/logging.service';
import { v4 as uuid4 } from "uuid";

const apiServer = environment.apiServer;
const MODULE_PATH = "TakomaClient.app.modules.other-kp.component.other-kp-main.other-kp-main-table";


declare var $: any;
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-other-kp-main-table',
  templateUrl: './other-kp-main-table.component.html',
  styleUrls: ['./other-kp-main-table.component.sass']
})

export class OtherKpMainTableComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  dataSetAuction: any;
  dtOptionsAuctions: DataTables.Settings = {};
  modelOtherKpFilter: OtherKpFilter = new OtherKpFilter();
  modelAuctionMainTable: OtherKpExportModel[];
  filterIsNotNull: boolean = true;
  defaultDateFrom: string;
  defaultDateTo: string;
  route: ActivatedRoute;

  dt: DataTables.Api;

  constructor(private http: HttpClient, private service: OtherKpDetailService, private _bus: BusOtherKpFilterService, private spinner: NgxSpinnerService, private _route: ActivatedRoute, private _loggingService: LoggingService) {
    this.modelAuctionMainTable = [];
    this.defaultDateFrom = this.getDateYYYYMMDD();
    this.defaultDateTo = this.getDateYYYYMMDD(true);
    this.route = _route;
    // const routeId = this.route.snapshot.paramMap.get('id');
    // if (routeId) {
    //   this.onRowClick(routeId);
    //   $('#modalOtherKpDetail').modal('toggle')
    // }
  }

  onFieldChange(): void {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onFieldChange', null, 'Field change started');
      this.dt.ajax.reload();
      this.modelAuctionMainTable = [];
      this.spinner.show();
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  onSelectedStatus(status) {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onSelectedStatus', null, 'Status selection started');
      this.modelOtherKpFilter.status = status;
      this.onFieldChange();
      this.spinner.show();
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onSelectedStatus', null, 'Status selected');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onSelectedStatus', _error, null, 'Status selection failed');
      throw _error;
    }
  }

  //Статус согласования аукциона
  onAdjustmentStatus(status) {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onAdjustmentStatus', null, 'Adjustment status started');
      this.modelOtherKpFilter.aucAgreementStatus = status;
      this.onFieldChange();
      this.spinner.show();
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onAdjustmentStatus', null, 'Adjustment status set');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onAdjustmentStatus', _error, null, 'Adjustment status failed');
      throw _error;
    }
  }

  onExport(): void {
    const _xid = this._loggingService.generateUUID();
    this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onExport', null, 'Export started');

    this.modelAuctionMainTable = [];

    const optionsCvs = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      useBom: true,
      noDownload: false,
      headers: [
        'Статус',
        'ID',
        'Номер извещения',
        'КАМ',
        'Заказчик',
        'ДБ',
        'Сумма КП ВСЕГО',
        'Поз-й',
        'Дата подачи']
    };
    const filter = {
      DateAucFrom: this.modelOtherKpFilter.dateAucFrom,
      DateAucTo: this.modelOtherKpFilter.dateAucTo,
      SearchMainField: this.modelOtherKpFilter.searchMainField,
      Customer: this.modelOtherKpFilter.customer,
      Distributor: this.modelOtherKpFilter.distributor,
      Kam: this.modelOtherKpFilter.kam,
      Status: this.modelOtherKpFilter.status,
      Region: this.modelOtherKpFilter.region,
      AmountPosition: this.modelOtherKpFilter.amountPosition,
      aucAgreementStatus: this.modelOtherKpFilter.aucAgreementStatus,
      Mnn: this.modelOtherKpFilter.mnn,
      start: 0,
      length: 100000,
      columns: [
        {
          data: 'statusKP', name: 'statusKP'
        },
        {
          data: 'id', name: 'id'
        },
        {
          data: 'noticeId', name: 'noticeId'
        },
        {
          data: 'kamName', name: 'kamName'
        },
        {
          data: 'customerName', name: 'customerName'
        },
        {
          data: 'distributorName', name: 'distributorName'
        },
        {
          data: 'summKp', name: 'summKp'
        },
        {
          data: 'amountPosition', name: 'amountPosition'
        },
        {
          data: 'dateCreate', name: 'dateCreate'
        }
      ],
      order: [{
        column: 8, dir: 'desc'
      }]
    };
    console.log(filter)

    this.http.post<any>(`${apiServer}/otherKp`, filter, {}).subscribe(result => {
      result.data.forEach(item => {
        const auctionItem = new OtherKpExportModel();
        for (const key in item) {
          if (key in auctionItem) {
            if (key === 'id') {
              auctionItem[key] = item[key] + ' ';
            } else {
              auctionItem[key] = item[key];
            }
            if (auctionItem[key] == null) {
              auctionItem[key] = '';
            }
          }
        }
        this.modelAuctionMainTable.push(auctionItem);
      });

      const n = new Angular5Csv(this.modelAuctionMainTable, 'OtherKps', optionsCvs);
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onExport', null, 'Export completed');
    }, error => {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onExport', error, null, 'Export failed');
    });

  }

  onDateChange(event) {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onDateChange', null, 'Date change started');
      this.modelOtherKpFilter[event.target.name] = event.target.value;
      this.filterIsNotNull = false;
      this._bus.changeFilter(this.modelOtherKpFilter);
      this.modelAuctionMainTable = [];
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onDateChange', null, 'Date changed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onDateChange', _error, null, 'Date change failed');
      throw _error;
    }
  }

  onRowClick(otherKp: OtherKpModel) {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onRowClick', null, 'Row click started');
      this.service.isOpeningKp = true;
      this.service.openOtherKp(otherKp, this.spinner);
      $('#modalOtherKpDetail').modal('toggle');
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onRowClick', null, 'Row clicked');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onRowClick', _error, null, 'Row click failed');
      throw _error;
    }
  }

  add() {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.add', null, 'Add started');
      this.service.isOpeningKp = true;
      this.service.getNew(this.spinner);
      $('#modalOtherKpDetail').modal('toggle');
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.add', null, 'Add completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.add', _error, null, 'Add failed');
      throw _error;
    }
  }

  onClearTotal() {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onClearTotal', null, 'Clear total started');

      this.modelOtherKpFilter.dateAucFrom = "";
      this.modelOtherKpFilter.dateAucTo = "";
      this.modelOtherKpFilter.searchMainField = null;
      this.modelOtherKpFilter.kam = null;
      this.modelOtherKpFilter.status = null;
      this.modelOtherKpFilter.region = null;
      this.modelOtherKpFilter.customer = null;
      this.modelOtherKpFilter.distributor = null;
      this.modelOtherKpFilter.aucAgreementStatus = null;
      this.modelOtherKpFilter.mnn = null;

      this._bus.changeClearModalFilter('kam');
      this._bus.changeClearModalFilter('distributor');
      this._bus.changeClearModalFilter('region');
      this._bus.changeClearModalFilter('customer');
      this._bus.changeClearModalFilter('mnn');

      this.filterIsNotNull = true;
      this.onFieldChange();
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onClearTotal', null, 'Clear total completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onClearTotal', _error, null, 'Clear total failed');
      throw _error;
    }
  }

  onClearModal(key: string) {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onClearModal', null, 'Clear modal started');
      this.filterIsNotNull = true;
      this._bus.changeClearModalFilter(key);
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onClearModal', null, 'Clear modal completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onClearModal', _error, null, 'Clear modal failed');
      throw _error;
    }
  }
  onClearSearchFields(key: string) {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onClearSearchFields', null, 'Clear search fields started');
      this._bus.changeClearSearchModalFields(key);
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onClearSearchFields', null, 'Clear search fields completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onClearSearchFields', _error, null, 'Clear search fields failed');
      throw _error;
    }
  }

  onClearDateFields(key: string) {
    const _xid = this._loggingService.generateUUID();
    try {
      this._loggingService.logStart(_xid, 'App.Components.OtherKpMainTableComponent.onClearDateFields', null, 'Clear date fields started');
      this.filterIsNotNull = true;
      Object.keys(this.modelOtherKpFilter).forEach(name => {
        if (name === key && this.modelOtherKpFilter[name] != null) {

          switch (name) {
            case 'dateAucFrom':
              this.modelOtherKpFilter[name] = this.defaultDateFrom;
              break;
            case 'dateAucTo':
              this.modelOtherKpFilter[name] = this.defaultDateTo;
              break;

            default:
              this.modelOtherKpFilter[name] = null;
              break;
          }
        }
      });
      this.onFieldChange();
      this._loggingService.logFinish(_xid, 'App.Components.OtherKpMainTableComponent.onClearDateFields', null, 'Clear date fields completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.OtherKpMainTableComponent.onClearDateFields', _error, null, 'Clear date fields failed');
      throw _error;
    }
  }


  ngOnInit(): void {
    this.spinner.show();
    this.subs.push(
      this._bus.currentFilter$.subscribe(customСommercialOfferFilter => {
        const xid = uuid4();
        const qualName = `${MODULE_PATH}.OtherKpMainTableComponent.lambda`;
        const inputParams = { "customСommercialOfferFilter": customСommercialOfferFilter };
        const description = "[MessageRecipient] Изменение фильтра таблицы пользовательских КП";

        try {
          this._loggingService.logStart(xid, qualName, inputParams, description);

          // Eminov Rasim: Deprecated since 2026-01-16
          // this.modelOtherKpFilter = customСommercialOfferFilter;

          this.modelOtherKpFilter = {
            ...this.modelOtherKpFilter,
            ...customСommercialOfferFilter
          };

          if (this.dt != null) {
            this.onFieldChange();
          }

          this._loggingService.logFinish(xid, qualName, inputParams, description);
        } catch (error) {
          this._loggingService.logError(xid, qualName, error, inputParams, description);
          throw error;
        }
      })
    );

    this.subs.push(this.service.reloadTable$.subscribe(() => {
      this.dt.ajax.reload();
      this.modelAuctionMainTable = [];
      this.spinner.show();
    }));

    $('#dateAucFrom').val(this.defaultDateFrom);
    this.modelOtherKpFilter.dateAucFrom = this.defaultDateFrom;

    $('#dateAucTo').val(this.defaultDateTo);
    this.modelOtherKpFilter.dateAucTo = this.defaultDateTo;


    const that = this;

    this.dtOptionsAuctions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: true,
      dom: 'tip',
      info: false,
      scrollY: 'calc(100vh - 230px)',
      //scrollCollapse: true,
      //scrollX: true,
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        },
      },
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.DateAucFrom = this.modelOtherKpFilter.dateAucFrom;
        dataTablesParameters.dateAucTo = this.modelOtherKpFilter.dateAucTo;
        dataTablesParameters.SearchMainField = this.modelOtherKpFilter.searchMainField;
        dataTablesParameters.Customer = this.modelOtherKpFilter.customer;
        dataTablesParameters.Kam = this.modelOtherKpFilter.kam;
        dataTablesParameters.AmountPosition = this.modelOtherKpFilter.amountPosition;
        dataTablesParameters.Status = this.modelOtherKpFilter.status;
        dataTablesParameters.Region = this.modelOtherKpFilter.region;
        dataTablesParameters.Distributor = this.modelOtherKpFilter.distributor;
        dataTablesParameters.AucAgreementStatus = this.modelOtherKpFilter.aucAgreementStatus;
        dataTablesParameters.Mnn = this.modelOtherKpFilter.mnn;

        this.http.post<DataTablesResponse>(`${apiServer}/otherKp`, dataTablesParameters, {})
          .pipe(
            tap((response: DataTablesResponse) => {
              this.dataSetAuction = response.data;

              callback({
                recordsTotal: response.recordsTotal,
                recordsFiltered: response.recordsFiltered,
                data: [],
              });
            }),
            catchError((_error: HttpErrorResponse) => {
              this.dataSetAuction = [];

              return of();
            }),
            finalize(() => {
              this.spinner.hide()
            })
          )
          .subscribe();
      },
      columns: [
        { data: 'statusKP', width: '70px' },
        { data: 'id', width: '110px' },
        { data: 'noticeId', width: '110px' },
        { data: 'kamName', width: '100px' },
        { data: 'customerName', width: '510px' },
        { data: 'distributorName', width: '120px' },
        { data: 'summKp', width: '120px' },
        { data: 'amountPosition', width: '40px' },
        { data: 'dateCreate', width: '130px' },
      ],
      order: [[8, 'desc']]
    };

  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
    $('.datetimepickers').each(function () {
      $(this).datetimepicker({
        locale: 'ru',
        format: 'YYYY-MM-DD',
        collapse: true,
        keepOpen: false,
        useCurrent: false,
        showClear: false

      });
    });

    $('[data-toggle="tooltip"]').tooltip();
  }

  getDateYYYYMMDD(to: boolean = false) {
    if (!to) {
      var dateTo = new Date();
      dateTo.setDate(new Date().getDate() - 50);
      return dateTo.toISOString().slice(0, 10);
    }
    else {
      return new Date().toISOString().slice(0, 10);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-table.component.ts